import { useEffect, useRef, useState } from "react";

const testimonials = [
  {
    quote:
      "«Для нас майже неможливо працювати без системи автоматизації. Наразі в базі понад 10 тис. резюме».",
    name: "Тетяна Режевська",
    role: "керівниця відділу з підбору персоналу компанії «Viyar»",
    company: "Viyar",
    logo: "https://storage.readdy-site.link/project_files/7cf81fbf-fb7d-4618-bb94-f6f654527b2e/dd9833e2-be46-40b1-a9d3-6c3200c548fa_Logo-Viyar-syno-zhovte-rgb.png?v=c11aa0374ba6f6a6ae92a44e7d05ea6b",
    accent: "#d6e8f3",
    textBg: "#f2f7fa",
  },
  {
    quote:
      "«В HURMA я кожного дня роблю звіти, бачу тенденцію, бачу динаміку. Я роблю це за декілька хвилин. Я не сиджу пів дня над звітністю».",
    name: "Ольга Кухтіна",
    role: "менеджер з розвитку персоналу та HR-проєктів Аптеки 9-1-1",
    company: "Аптека 9-1-1",
    logo: "https://storage.readdy-site.link/project_files/7cf81fbf-fb7d-4618-bb94-f6f654527b2e/5366da6c-9b77-4bfb-a5b6-ab455c01a1b7_9f3ba0_64d6e9876597498189a30b6517cd5446mv2-1.png?v=52f0e7b5ec2781e7647698d144145a03",
    accent: "#f3d6d6",
    textBg: "#faf2f2",
  },
  {
    quote:
      "«З HURMA AI система сама підтримує контакт, поки ми займаємося іншими задачами. Тепер кандидати не зникають — вони приходять. І повернутися до таблиць тепер — це як добровільно віддати конкурентам перевагу, яку ми так довго будували».",
    name: "HR-директор",
    role: "велика ресторанна мережа України",
    company: "HoReCa",
    accent: "#e8f3d6",
    textBg: "#f7faf2",
  },
];

export default function IndustriesSection() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const sliderRef = useRef<HTMLDivElement>(null);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const children = entry.target.querySelectorAll(".industry-animate");
            children.forEach((child, i) => {
              setTimeout(() => child.classList.add("visible"), i * 100);
            });
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const slider = sliderRef.current;
    if (!slider) return;
    const handleScroll = () => {
      const scrollLeft = slider.scrollLeft;
      const cardWidth = slider.firstElementChild
        ? (slider.firstElementChild as HTMLElement).offsetWidth + 20
        : 600;
      const idx = Math.round(scrollLeft / cardWidth);
      // -1 to skip the fake spacer card, clamp to [0, testimonials.length - 1]
      setActiveIndex(Math.max(0, Math.min(idx - 1, testimonials.length - 1)));
    };
    slider.addEventListener("scroll", handleScroll, { passive: true });
    return () => slider.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToCard = (index: number) => {
    const slider = sliderRef.current;
    if (!slider) return;
    // +1 because first child is the fake spacer card
    const card = slider.children[index + 1] as HTMLElement;
    if (!card) return;
    slider.scrollTo({
      left: card.offsetLeft - slider.offsetLeft,
      behavior: "smooth",
    });
  };

  return (
    <section
      id="industries"
      ref={sectionRef}
      className="relative py-20 md:py-28 bg-white overflow-hidden"
    >
      <div className="max-w-[1024px] mx-auto px-6">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="industry-animate animate-on-scroll text-[32px] sm:text-[40px] lg:text-[48px] font-semibold leading-[1.1] tracking-tight text-[#1d1d1f] mb-5">
            HURMA створена для
            <br />
            <span className="text-[#86868b]">
              компаній із постійним потоком вакансій
            </span>
          </h2>
          <p className="industry-animate animate-on-scroll text-[17px] text-[#86868b] leading-relaxed max-w-[720px] mx-auto text-center">
            АЗС, аптеки, FMCG, HoReCa, логістика, виробництво — там, де щодня
            відкриваються нові позиції, кандидати приходять з різних міст, а
            швидкість відповіді напряму впливає на результат та вартість.
          </p>
        </div>
      </div>

      {/* Testimonials — Apple-style cards */}
      <div className="industry-animate animate-on-scroll">
        <div
          ref={sliderRef}
          className="overflow-x-auto snap-x snap-mandatory [scrollbar-width:none] [&::-webkit-scrollbar]:hidden flex gap-5 md:gap-6 pl-6 md:pl-12 pr-6 md:pr-12 pb-4"
        >
          {/* Fake empty spacer card */}
          <div
            className="hidden md:block snap-start flex-shrink-0 w-[50vw] sm:w-[250px] md:w-[290px] lg:w-[310px] rounded-[28px] overflow-hidden"
            style={{ backgroundColor: 'transparent' }}
          />

          {testimonials.map((t, i) => (
            <div
              key={i}
              className="snap-start flex-shrink-0 w-[85vw] sm:w-[400px] md:w-[440px] lg:w-[480px] rounded-[20px] p-6 md:p-8 flex flex-col justify-between relative overflow-hidden"
              style={{ backgroundColor: t.textBg, minHeight: '300px' }}
            >
              <p className="text-[16px] md:text-[17px] font-medium leading-[1.55] text-[#1d1d1f] mb-6 md:mb-8 flex-1">
                {t.quote}
              </p>

              <div className="flex items-center gap-3">
                <div className="min-w-0 flex-1">
                  <p className="text-[13px] md:text-[14px] font-semibold text-[#1d1d1f] truncate">
                    {t.name}
                  </p>
                  <p className="text-[11px] md:text-[12px] text-[#86868b] leading-snug truncate">
                    {t.role}
                  </p>
                </div>
                {t.logo ? (
                  <div
                    className="flex-shrink-0 inline-flex items-center justify-center px-3 py-1.5 rounded-full"
                    style={{ backgroundColor: t.accent }}
                  >
                    <img
                      src={t.logo}
                      alt={t.company}
                      className="h-6 md:h-8 w-auto object-contain max-w-[100px] md:max-w-[130px]"
                    />
                  </div>
                ) : (
                  <span
                    className="flex-shrink-0 inline-block px-3 py-1 rounded-full text-[11px] font-semibold"
                    style={{ backgroundColor: t.accent, color: '#1d1d1f' }}
                  >
                    {t.company}
                  </span>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Dots */}
        <div className="flex items-center justify-center gap-2 mt-6 px-6 md:px-12">
          {testimonials.map((_, i) => (
            <button
              key={i}
              onClick={() => scrollToCard(i)}
              className={`w-3 h-3 rounded-full transition-colors cursor-pointer ${
                i === activeIndex ? "bg-[#1d1d1f]" : "bg-[#d2d2d7] hover:bg-[#86868b]"
              }`}
              aria-label={`Відгук ${i + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}